import { z } from 'zod';
export function createSearchSchema<T extends readonly [string, ...string[]]>(sortableColumnKeys: T) {
  return z.object({
    freeText: z.string().optional(),
    softwareIdIn: z.array(z.string()).optional(),
    pageIndex: z.number().default(0),
    pageSize: z.number().default(100),
    // 古いブックマークや手打ち URL で不正なソート指定が渡っても validateSearch を
    // throw させず、未ソート扱いにフォールバックする(例: 旧 `.` 区切りの sortColumn)。
    sortColumn: z.enum(sortableColumnKeys).optional().catch(undefined),
    sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined)
  });
}